export type SiteId = number;
type AccountId = number;
type OrganisationId = number;

type Access = 'admin' | 'write' | 'read';

export type Feature = string;

export enum FeatureGroupEnum {
  basic,
  plus,
  business,
  scale,
}

export type FeatureGroup = keyof typeof FeatureGroupEnum;

interface EntityWithFeatures {
  features?: Array<Feature>;
}

interface EntityWithAccess {
  access: Access;
}

export interface BaseSite {
  id: SiteId;
  userAttributesEnabled?: boolean;
  account: BaseAccount;
  organization: BaseOrganization;
}

export interface BaseAccount {
  id: AccountId;
}

export interface BaseOrganization {
  id: OrganisationId;
}

export interface SiteWithFeature extends EntityWithFeatures {
  effectivePlan: FeatureGroup | null;
  effectiveAskPlan: FeatureGroup | null;
  account: EntityWithFeatures;
  organization: EntityWithFeatures;
}

export interface SiteWithAccess {
  account: EntityWithAccess;
  organization: EntityWithAccess;
}
